import React, { useState, useEffect } from "react";
import { Switch, Space } from "antd";
import { getGlobalGeoEnabled, setGlobalGeoEnabled } from "../../../utils/watermarkSettings";

function Setting() {
    const [geoEnabled, setGeoEnabled] = useState(false);

    useEffect(() => {
        // init geolocation setting
        setGeoEnabled(getGlobalGeoEnabled());
    }, []);

    const saveGlobalGeo = (checked) => {
        setGeoEnabled(checked);
        setGlobalGeoEnabled(checked);
    };

    return (
        <>
            <div className="container-fluid white-back-cr">
                <div className="mb-3" style={{ background: "#fff", borderRadius: 8, padding: 12, border: "1px solid #eee" }}>
                    <Space direction="vertical" size="small" style={{ width: "100%" }}>
                        <div>
                            <b>Pengaturan Geolocation di Watermark</b>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>Tampilkan Geolocation (Global)</span>
                            <Switch checked={geoEnabled} onChange={saveGlobalGeo} />
                        </div>
                    </Space>
                </div>
            </div>
        </>
    );
}
export default Setting
